import request from '@/utils/request'
import base from "@/api/base";

export default {
    //查询分类列表
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/getMemberVersionList`, params),
    //修改分类
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/updateMemberVersion`, params),
}